/****************************************************
 * Module Name:  restAPICall.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import createURLQuery from "./queryStringGenerator";
import Constants from "../constants";
import Utility from "../utility";

function handleResponse(ignoreHandle401Check, response) {
  //Unauthorized status code 401
  if (!ignoreHandle401Check && response.status === 401) {
    //Since authentication failure occured reset out screen to main home page
    //so that user can login again
    if (response.url.includes(Constants.MANAGER_URL)) {
      //Do this only if url we tried is our manager url only
      Utility.ReloadSite();
    }
  }

  if (!response.ok) {
    const error = { status: response.status, statusText: response.statusText };
    return Promise.reject(error);
  }

  try {
    if (response.status === 204) {
      Promise.resolve();
    }
    return response.json();
  } catch {
    return Promise.resolve();
  }
}

function getAuthorizationToken(token) {
  if (token === undefined || token === null || token === "")
    return undefined;

  return "Bearer " + token;
}

const restAPICall = (
  apiURL,
  httpMethod,
  authorizationToken,
  params,
  httpBody,
  contentType,
  RETRY_API_COUNT = 0,
  ignoreHandle401Check = false
) => {
  let header = undefined;

  //Don't move this logic insider options json as it is failing in some api otherwise
  if (contentType === undefined)
    header = {
      "Accept": "application/json",
      "Authorization": getAuthorizationToken(authorizationToken),

    };
  else
    header = {
      "Accept": "application/json",
      "Authorization": getAuthorizationToken(authorizationToken),
      "Content-Type": "application/json",
    };

  const endpointUrl = apiURL;
  const options = {
    method: httpMethod,
    headers: header,
    body: httpBody,
    timeout: 0,
  };

  if (!endpointUrl) {
    throw new Error();
  }

  return fetch(
    params === undefined ? endpointUrl : createURLQuery(params, endpointUrl),
    options
  ).then((response) => handleResponse(ignoreHandle401Check, response));
  /*.then(response => response.json())
    .catch(function(error) {
        if (RETRY_API_COUNT === 0 || error.toString().substring(0,12) === 'SyntaxError:' || error.toString() === 'TypeError: Failed to fetch') {
            return (error);
        }
        let releaseTimer = setTimeout(() => {
            clearTimeout(releaseTimer);
            restAPICall(apiURL, httpMethod, authorizationToken, params, httpBody, contentType, RETRY_API_COUNT - 1);
        }, 5000);
    });*/
};

export default restAPICall;
